module.exports = __webpack_public_path__ + "img/3ad8963781b9389652e4ce84d194f0c8.svg";